import cron from "./cron";
import status from "./status";
import newsletter from "./newsletter";
import report from "./report";
import page from "./page";
import culture from "./culture";
import weight from "./weight";
import study from "./study";

export default {
  cron,
  status,
  newsletter,
  report,
  page,
  culture,
  weight,
  study,
};
